import React, { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NewGuarantee from "../components/core/guarantee/NewGuarantee";
import GuaranteeServiceTicket from "../components/core/guarantee/GuaranteeServiceTicket";
import { GuaranteeService } from "../services/guarantee.service";
import { connect } from "react-redux";
import { actions } from "../redux/actions/alert";

const ContainerGuaranteeDetail = ({ addAlert, detailAlert, history }) => {
  const location = useLocation();

  // const [siteId, setSiteId] = useState({});
  const [guaranteeInfo, setGuaranteeInfo] = useState(undefined);

  useEffect(() => {
    // const currentUserValue = AuthService.currentUserValue;
    // setSiteId(currentUserValue.siteId);
    const guaranteeId = location.pathname.split("/")[4];

    if (guaranteeId) {
      (async () => {
        try {
          const { data } = await GuaranteeService.getGuaranteeById(guaranteeId);
          setGuaranteeInfo(data);
        } catch (error) {
          addAlert({ showAlert: true });
          detailAlert({ severity: "error", message: error.msgs, time: 2000 });
        }
      })();
    } else {
      history.push("/dashboard/inventario");
    }
  }, []);

  return (
    <>
      {guaranteeInfo !== undefined && (
        <Fragment>
          <NewGuarantee guaranteeInfo={guaranteeInfo} />
          <GuaranteeServiceTicket guaranteeInfo={guaranteeInfo} />
        </Fragment>
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(ContainerGuaranteeDetail);
